import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { WebSocketService } from 'src/app/services/web-socket-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.sass'],
  standalone: true,
  imports: []
})
export class AdminLoginComponent {
  loader = document.getElementById("loader-container");
  paramId: any;

  constructor(private activatedRoute: ActivatedRoute, private webSocketService: WebSocketService) {
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.paramId = params['id'];
      this.paramId && this.webSocketService.connect(this.paramId, environment.webSocketUrl);
  });
  }
}
